// A running log of every action the player takes and the resulting stat
// deltas, shown by ActionLog.svelte. Rather than threading an action name
// through every *Effects descriptor array (AloneActionsList.svelte,
// jobs.js, ItemsList.svelte, stores.js's sleep()), withActionLog() snapshots
// every stat store before/after running the action and diffs them — so it
// captures a stat change no matter how the action applies it (declarative
// applyEffects() or a raw store update), from a single call site per action
// trigger (AloneAction.svelte, Action_Job.svelte, ItemsList.svelte, sleep()).
import { writable, get } from 'svelte/store';
import * as Stats from './stats.js';
import { STAT_META } from './effects.js';

const MAX_ENTRIES = 50;
const DELTA_EPSILON = 0.0005;

function humanize(key) {
    return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export const actionLog = writable([]);
let nextId = 0;

export function withActionLog(name, fn) {
    const before = Object.entries(Stats).map(([key, store]) => [key, store, get(store)]);
    const result = fn();

    const deltas = [];
    for (const [key, store, prevValue] of before) {
        const delta = get(store) - prevValue;
        if (Math.abs(delta) < DELTA_EPSILON) continue;
        const meta = STAT_META.get(store);
        const label = meta ? meta.label : humanize(key);
        const good = meta ? (delta > 0 ? 1 : -1) * meta.good > 0 : delta > 0;
        deltas.push({ label, delta, good });
    }

    actionLog.update(entries => [{ id: nextId++, name, deltas }, ...entries].slice(0, MAX_ENTRIES));
    return result;
}
